import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { nanoid } from '@reduxjs/toolkit';
//import { fetchPosts } from '../actions/postsActions';
//import { Post } from '../components/Post';
import { useViewportSize } from '@mantine/hooks';
import {
    Progress,
    Text,
    ScrollArea
} from '@mantine/core';
import { useSelector } from 'react-redux';
import { FooterSimple } from '../components/FooterSimple';
import { MobileSimpleHeader } from '../components/MobileSimpleHeader';
import { StaffFilter } from '../components/StaffFilter';
import StaffItem from '../components/StaffItem';

import pagani from '../assets/pagani.jpg';

//this needs params
const StaffPage = () => {
    const { height, width } = useViewportSize();
    return (
        <>
            {/*<MobileSimpleHeader 
                avatar={pagani}
                drawSubSectMenu={false}
            />
            have a switch case for assignment of the sub menu*/}
            <StaffFilter />
            <ScrollArea
                type="never"
                 h={height * 0.65}
            >
                <StaffItem
                    avatar={pagani}
                    username={"staff_username"}
                    name="JohnDoe"
                    status={"active"}
                    lastAccess={"05/24/2023 @ 11:59PM PST"}
                    role={"Salesman"}
                />
                <br/>
                <StaffItem
                    avatar={pagani}
                    username={"staff_username"}
                    name="JohnDoe"
                    status={"active"}
                    lastAccess={"05/24/2023 @ 11:59PM PST"}
                    role={"Salesman"}
                />
                <br/>
                <StaffItem
                    avatar={pagani}
                    username={"staff_username"}
                    name="JohnDoe"
                    status={"active"}
                    lastAccess={"05/24/2023 @ 11:59PM PST"}
                    role={"Salesman"}
                />
                <br/>
                <StaffItem
                    avatar={pagani}
                    username={"staff_username"}
                    name="JohnDoe"
                    status={"active"}
                    lastAccess={"05/24/2023 @ 11:59PM PST"}
                    role={"Salesman"}
                />
                <br/>
                <StaffItem
                    avatar={pagani}
                    username={"staff_username"}
                    name="JohnDoe"
                    status={"active"}
                    lastAccess={"05/24/2023 @ 11:59PM PST"}
                    role={"Salesman"}
                />
                <br/>
                <StaffItem
                    avatar={pagani}
                    username={"staff_username"}
                    name="JohnDoe"
                    status={"active"}
                    lastAccess={"05/24/2023 @ 11:59PM PST"}
                    role={"Salesman"}
                />
                <br/>
                <StaffItem
                    avatar={pagani}
                    username={"staff_username"}
                    name="JohnDoe"
                    status={"active"}
                    lastAccess={"05/24/2023 @ 11:59PM PST"}
                    role={"Salesman"}
                />
                <br/>
                <StaffItem
                    avatar={pagani}
                    username={"staff_username"}
                    name="JohnDoe"
                    status={"active"}
                    lastAccess={"05/24/2023 @ 11:59PM PST"}
                    role={"Salesman"}
                />
                <br/>
                <StaffItem
                    avatar={pagani}
                    username={"staff_username"}
                    name="JohnDoe"
                    status={"active"}
                    lastAccess={"05/24/2023 @ 11:59PM PST"}
                    role={"Salesman"}
                />
                <br/>
                <StaffItem
                    avatar={pagani}
                    username={"staff_username"}
                    name="JohnDoe"
                    status={"active"}
                    lastAccess={"05/24/2023 @ 11:59PM PST"}
                    role={"Salesman"}
                />
                <br/>
            </ScrollArea>
            <FooterSimple />
        </>
    )

}

export default StaffPage
